import { useState } from "react";
import { Button } from "react-aria-components";

import "yet-another-react-lightbox/styles.css";
import Lightbox from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";

import { getImageUrl } from "@/supabase/storage";

import { buildGallerySlide } from "./utils";

type Photo = {
  id: number;
  storagePath: string;
  filename: string;
  caption: string | null;
  photographer: string | null;
};

export function GalleryGrid({
  photos,
  tournamentName,
}: {
  photos: Photo[];
  tournamentName: string;
}) {
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  if (photos.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-gray-500">No photos yet.</p>
    );
  }

  const slides = photos.map((p, i) => buildGallerySlide(p, i, tournamentName));

  return (
    <>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {photos.map((photo, i) => (
          <Button
            key={photo.id}
            onPress={() => setLightboxIndex(i)}
            className="group relative aspect-square cursor-pointer overflow-hidden rounded-md"
          >
            <img
              src={getImageUrl("tournament_gallery_photos", photo.storagePath, {
                width: 400,
                height: 400,
                quality: 75,
              })}
              alt={photo.caption || photo.filename}
              loading="lazy"
              className="h-full w-full object-cover transition-transform group-hover:scale-105"
            />
            {(photo.caption || photo.photographer) && (
              <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-2">
                {photo.caption && (
                  <p className="truncate text-xs text-white">{photo.caption}</p>
                )}
                {photo.photographer && (
                  <p className="truncate text-xs text-white/70">
                    {photo.photographer}
                  </p>
                )}
              </div>
            )}
          </Button>
        ))}
      </div>

      <Lightbox
        open={lightboxIndex >= 0}
        close={() => setLightboxIndex(-1)}
        index={lightboxIndex}
        slides={slides}
        plugins={[Download]}
      />
    </>
  );
}
